import { memo } from 'react';
import { useTheme } from '@mui/material';
import { ReactComponent as EmailIllustrationLight } from './email.svg';
import { ReactComponent as EmailIllustrationDark } from './email_dark.svg';

export const EmailIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <EmailIllustrationDark aria-hidden="true" {...props} />;
    return <EmailIllustrationLight aria-hidden="true" {...props} />;
  },
);
